import { render, staticRenderFns } from "./SkupoviSuorganizatori.vue?vue&type=template&id=0f11682c&scoped=true&"
import script from "./SkupoviSuorganizatori.vue?vue&type=script&lang=js&"
export * from "./SkupoviSuorganizatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11682c",
  null
  
)

export default component.exports